import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subestadoTarea',
  standalone: true
})
export class SubestadoTareaPipe implements PipeTransform {

  transform(value: number): unknown {
    const estados = [
      "PENDIENTE",  //0
      "FINALIZADO", //1
      "CANCELADO",  //2
    ];
    return estados[value]||'';
  }

}
